import SubmitAppointment from "./SubmitAppointmentComponent";

export default function AppointmentRequestPage() {
    return (
        <div className="ml-2">
            <div className="top-[20px] z-30 bg-[#edeef2]">
                <div className="flex items-center justify-between py-4 px-4 sm:px-6">
                    <h1 className="text-base sm:text-xl font-bold text-gray-900">
                        Make An Appointment
                    </h1>
                </div>
            </div>
            <SubmitAppointment />
        </div>
    );
}